import { Component, OnInit, ViewChild, ElementRef, isDevMode } from '@angular/core';
import { MultiInputStepComponent } from '../../step/multi-input-step/multi-input-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-zip-code-street-address',
  templateUrl: './zip-code-street-address.component.html',
  styleUrls: ['./zip-code-street-address.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class ZipCodeStreetAddressComponent extends MultiInputStepComponent implements OnInit {
  @ViewChild('zipCode') zipCodeField: ElementRef;
  @ViewChild('streetAddress') streetAddressField: ElementRef;
 
  protected propertyTypeName: String;
  public experiment: Boolean;
  public notDebtSettlement: Boolean;
  public subtext: String;
  public zipTitle: String = "What's your zip code?";
  public streetTitle: String = "Street address";
  public removeAssuranceABTest: boolean = false;
  // hideStreetAddress = false;
  showAddressInput = false
  
  ngOnInit() {
    // Zip code validation
    this.controls.push(new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]{5}$')]));
    // Street Address validation
    this.controls.push(new UntypedFormControl('', [Validators.required, Validators.pattern('^[\\s]*[A-Za-z0-9,#.\'-]+[A-Za-z0-9\\s,#.\'-]*$')]));

    this.form.addControl('zipCode', this.controls[0]);
    this.form.addControl('streetAddress', this.controls[1]);
    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        // if (variationData.enabledVariations.hasOwnProperty('showAddressInput')) {
        //   this.showAddressInput = false;
        // }
      }
    );

    if (!environment.production) {
      this.form.controls.zipCode.setValue(this.randomService.consumer.zipCode.toString());
      this.form.controls.streetAddress.setValue(this.randomService.consumer.streetAddress);
      this.showAddressInput = true;
    }

    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        this.removeAssuranceABTest = variationData.enabledVariations.hasOwnProperty('removeAssurance');
      }
    );
  }

  initStep() {
    this.subtext = this.form.controls.type.value == 'personalloan' ? '' : 'Used to verify home value';
    // check if notDebtSettlement
    this.notDebtSettlement = this.form.controls.formType.value != 'debtsettlement' && this.form.controls.formType.value != 'debtrelief';
    if(this.experiment) {
      // Street address first in experiment
      setTimeout(() => this.streetAddressField.nativeElement.focus(), 0);
    } else {
      // Give zip code focus
      setTimeout(() => this.zipCodeField.nativeElement.focus(), 0);
    }
  }

  zipInput($event) {
    this.checkZipLength($event.target.value);
  }

  zipChange($event) {
    this.snap();
    this.checkZipLength($event.target.value);
  }

  checkZipLength(value: string) {
    if(value.length >= 5) {
      this.showAddressInput = true;
    }
  }

  submit() {
    // Get zip details
    this.fruHttpService.getZipDetails(this.controls[0].value, this.form.controls.type.value, this.form.controls.creditRating.value).subscribe((response) => {
      // if (response.enabled === false) {
      //   // Redirect if the state comes back disabled
      //   if (isDevMode()) {
      //     console.log('Zip code disabled state redirect');
      //   }
      //   this.fruHttpService.redirectRateTables(this.form);
      // } else if (response.lender && parseInt(response.lender) === 0) {
      //   // Redirect if lenders comes back as 0
      //   if (isDevMode()) {
      //     console.log('Zip code no lender redirect');
      //   }
      //   this.fruHttpService.redirectRateTables(this.form);
      // } else {
        // Populate state and city
        this.form.controls.propertyState.setValue(response.state || '');
        this.form.controls.propertyCity.setValue(response.city || '');
      // }
    });

    super.submit();
  }
}
